import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import { FileTextOutline, MessageSquareOutline } from '@lyearn/icons';
import { PlusOutline } from '@lyearn/icons';
import { IconButton, Popover, Stack, Typography } from '@lyearn/ui';

interface CreateNewPopoverProps {
  onNewChat: () => void;
  onNewNote: () => void;
  showNotesOnly?: boolean;
}

export const CreateNewHoverPopover = ({
  onNewChat,
  onNewNote,
  showNotesOnly = false,
}: CreateNewPopoverProps) => {
  const { t } = useTranslation();
  const [open, { off, toggle }] = useToggle();

  const popoverItems = [
    {
      icon: <MessageSquareOutline className="h-20 w-20" fillColorToken="icon-primary" />,
      label: t('Common:KnowledgeBase.Chat'),
      onClick: onNewChat,
      enabled: !showNotesOnly,
    },
    {
      icon: <FileTextOutline className="h-20 w-20" fillColorToken="icon-primary" />,
      label: t('Common:KnowledgeBase.Note'),
      onClick: onNewNote,
      enabled: true,
    },
  ];

  return (
    <Popover open={open} onOpenChange={toggle}>
      <Popover.Button>
        <IconButton Icon={PlusOutline} size="xl" variant="shadow">
          <PlusOutline />
        </IconButton>
      </Popover.Button>
      <Popover.Content>
        <Stack className="p-8" direction="col" gapY={2}>
          {popoverItems
            .filter((item) => item.enabled)
            .map(({ icon, label, onClick }) => (
              <Stack
                key={label}
                alignItems="center"
                className="px-12 py-[9px] hover:bg-bg-tertiary rounded-8 cursor-pointer"
                gapX={12}
                onClick={() => {
                  onClick();
                  off();
                }}>
                {icon}
                <Typography className="text-text-secondary" variant="body-short-02">
                  {label}
                </Typography>
              </Stack>
            ))}
        </Stack>
      </Popover.Content>
    </Popover>
  );
};
